import React from 'react';
import { Breadcrumbs } from '@material-ui/core';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import clsx from 'clsx';
import useStyles from './useStyles';

const AirBreadcrumbs = ({ children, className, ...others }) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.breadcrumbs, className)} {...others}>
      <Breadcrumbs separator={<NavigateNextIcon />} aria-label="breadcrumb">
        {children}
      </Breadcrumbs>
    </div>
  );
};

export default AirBreadcrumbs;
